import React from 'react';
import { ZodError } from 'zod';

import styles from './styles.module.css';

interface InputProps {
  type?: 'text' | 'password';
  placeholder?: string;
  value?: string;
  onChange?: (value: string) => void;
  customClass?: string;
  errors?: ZodError[];
}

const Input: React.FC<InputProps> = ({
  type = 'text',
  placeholder = '',
  value = '',
  onChange = () => {},
  customClass = '',
  errors = []
}) => {
  const inputClass = errors.length > 0 ? styles.inputError : styles.input;
  return (
    <div className={styles.inputContainer}>
      <input
        className={`${inputClass} ${customClass}`}
        type={type}
        placeholder={placeholder}
        value={value || ''}
        onChange={e => onChange(e.target.value)}
      />
      {errors ? (
        <div className={styles.error}>
          {errors.map(e => e?.message && e.message).join(', ')}
        </div>
      ) : null}
    </div>
  );
};

export default Input;
